<template>
    <div class="w-full">
        <animated-cta-button
            :is-disabled="!enableAddToCart"
            @click="continueToNextStep"
        >
            {{ buttonCopy }}
        </animated-cta-button>
        <!-- <base-button-flat
            @click="continueToNextStep"
            :variant="buttonVariant"
            class="w-full"
            :class="{ 'bg-red text-white bg-opacity-60 cursor-not-allowed': !enableAddToCart }"
        >
            {{ buttonCopy }}
        </base-button-flat> -->

        <cart-modal
            :show-modal="showModal"
            :updated="showModalUpdated"

            @modalClose="showModal = false"
        />

        <auto-modal
            v-if="addToCartError"
            :text="$t('UNEXPECTED_ERROR')"
            @close="closeAddToCartError"
        />
    </div>
</template>

<script>
    import allStores from '../../stores/all';
    import AnimatedCtaButton from './AnimatedCtaButton.vue';
    // import BaseButtonFlat from './BaseButtonFlat.vue';
    import CartModal from '../CartModal.vue';
    import AutoModal from '../AutoModal.vue';

    export default {
        mixins: [allStores],

        components: {
            AnimatedCtaButton,
            // BaseButtonFlat,
            CartModal,
            AutoModal,
        },

        data() {
            return {
                showModal: false,
                showModalUpdated: false,
                localError: false,
                addToCartError: false,
            };
        },

        computed: {
            currentGroup() {
                return this.customizerStore.currentGroup;
            },

            viewController() {
                return this.customizerStore.viewController;
            },

            allGroupsSeen() {
                return this.customizerStore.groupsSeen.length === this.visibleGroups.length;
            },

            visibleGroups() {
                return this.customizerStore.visibleGroups;
            },

            progressGroups() {
                return this.customizerStore.progressGroups;
            },

            selectionWasMade() {
                return this.customizerStore.selectionsMade.includes(this.currentGroup);
            },

            hasBeenSeen() {
                return this.customizerStore.groupsSeen.includes(this.currentGroup);
            },

            selectionsComplete() {
                return this.customizerStore.selectionsComplete;
            },

            totalSteps() {
                return this.customizerStore.totalSteps;
            },

            totalSelectionsMade() {
                return this.customizerStore.totalSelectionsMade;
            },

            enableAddToCart() {
                if (this.inErrorState) {
                    return false;
                }

                return this.totalSelectionsMade === this.totalSteps;
            },

            inErrorState() {
                return false;
            },

            productPrice() {
                return this.customizerStore.productPrice;
            },

            buttonCopy() {
                return this.isEditingFromCart ? `${this.$t('UPDATE_CART')}` : `${this.$t('ADD_TO_CART')}`;
            },

            buttonVariant() {
                const primaryStyle = this.selectionWasMade && this.hasBeenSeen ? 'primary' : 'primaryDisabled';

                return this.enableAddToCart || (this.isEditingFromCart && this.selectionWasMade) ? 'primary' : primaryStyle;
            },

            isEditingFromCart() {
                return this.customizerStore.options.lineItemId != null;
            },

            isMobile() {
                return this.appStore.isMobile;
            },
        },

        methods: {
            continueToNextStep() {
                if (!this.enableAddToCart) {
                    this.customizerStore.addPanelToErrorState('Main');

                    if (this.isMobile) {
                        // add all groups to seen for displaying error state
                        this.progressGroups.forEach((group) => {
                            this.customizerStore.addGroupToSeen(group.name);
                        });
                        this.appStore.setShouldShowViewAll(true);
                    }
                    return;
                }

                if (this.enableAddToCart) {
                    this.customizerStore.removePanelFromErrorState('Main');

                    this.addToCart();
                } else if (this.selectionWasMade) {
                    if (!this.isMobile) {
                        this.enableNextStep();
                    }

                    this.$emit('goNext');
                } else {
                    this.customizerStore.removePanelFromErrorState('Main');
                }
            },

            enableNextStep() {
                this.customizerStore.enableNextGroup();
            },

            addToCart() {
                this.customizerStore.addCurrentSelectionsToCart().catch(() => {
                    this.appStore.setIsBusy(false);
                    this.addToCartError = true;
                });
            },

            closeAddToCartError() {
                this.addToCartError = false;
            },
        },
    };
</script>
